import React, { useState, useEffect } from 'react';
import { GetNotificationRead } from '../../services/userAuthServices';
import { NotificationOfflineInfo,NotificationOnlineInfo, AlertNotifExtreme, AlertNotifHigh, AlertNotifLow, AlertNotifMedium, HMNotifOnline, HmNotifOffline, HMNotificationOnline, HMNotificationOffline, HMNotificationUnknown } from '../../assets/images'


const NotificationItem = ({ item }) => {
    const [isVisible, setIsVisible] = useState(true);
    const [severityType, setSeverityType] = useState("");
   
    useEffect(() => {
        let temp = JSON.parse(item?.NotificationData.replaceAll('\n',' '));
        const dataStr = temp?.data || "";
        const titleStr = temp?.Title || "";
        
        // Get the first line of data
        const firstLineData = dataStr.split('\n')[0]?.toLowerCase() || "";
        const titleLower = titleStr.toLowerCase();

        // First check the first line of data for status keywords
        if (firstLineData.includes("faulty") || firstLineData.includes("offline")) {
            setSeverityType("offline");
        } else if (firstLineData.includes("normal") || firstLineData.includes("online")) {
            setSeverityType("online");
        } else if (firstLineData.includes("unknown") || firstLineData.includes("unavailable")) {
            setSeverityType("unknown");
        }
        // If not found in first line of data, check the Title
        else if (titleLower.includes("faulty") || titleLower.includes("offline")) {
            setSeverityType("offline");
        }else if (titleLower.includes("normal") || titleLower.includes("online")) {
            setSeverityType("online");
        }else if (titleLower.includes("unknown") || titleLower.includes("unavailable")) {
            setSeverityType("unknown");
        }
        // If status not found in data or title, use severityId
        else if(temp.severityId == "1"){
                    setSeverityType("extreme")
            }else if(temp.severityId == "2"){
                    setSeverityType("high")
            }else if(temp.severityId == "3"){
                    setSeverityType("moderate")
            }else if(temp.severityId == "4"){
                    setSeverityType("low")
            }else{
                    setSeverityType("")
            }
        //    console.log("severityType"+severityType);
     }, [item]);

    const NotificationRead = (notificationId) => {
        GetNotificationRead(notificationId)
            .then((res) => {
                if (res.Status === "success") {
                    setIsVisible(false);
                    // document.getElementsByClassName('badge')[0].innerText = parseInt(document.getElementsByClassName('badge')[0].innerText)-1;
                    document.getElementsByClassName('badgeUnread')[0].innerText = parseInt(document.getElementsByClassName('badgeUnread')[0].innerText)-1;
                    document.getElementsByClassName('badgenotify')[0].innerText = parseInt(document.getElementsByClassName('badgenotify')[0].innerText)-1;
                }
            }).catch(err => console.log(err));
    }

    return (
        <div className="NotificationListItem">
            <div className="ItemOnlineStatus">
            {
                severityType == "extreme"
                ? 
                <div className='AlertImgBg' style={{ backgroundColor: "#FFC3C3" }}>
                      <img className='AlertImgIcon' src={AlertNotifExtreme} alt="Notification Alert Red" />
                </div> 
                : severityType == "high"
                ? 
                <div className='AlertImgBg' style={{ backgroundColor: "#FFD0BF" }}>
                    <img className='AlertImgIcon' src={AlertNotifHigh} alt="Notification Alert Red" />
                </div>
                : severityType == "moderate"
                ? 
                <div className='AlertImgBg' style={{ backgroundColor: "#FFEFC4" }}>
                    <img className='AlertImgIcon' src={AlertNotifMedium} alt="Notification Alert Red" />
                </div>
                : severityType == "low"
                ? 
                <div className='AlertImgBg' style={{ backgroundColor: "#E7FFC3" }}>
                    <img className='AlertImgIcon' src={AlertNotifLow} alt="Notification Alert Red" />
                </div>
                : severityType == "online"
                ?
                <div className='AlertImgBg' style={{ backgroundColor: "#E6FFC3" }}>
                    <img className='AlertImgIcon' src={HMNotificationOnline} alt="Notification Alert Red" />
                </div>
                : severityType == "offline"
                ?
                <div className='AlertImgBg' style={{ backgroundColor: "#FFC3C3" }} >
                    <img className='AlertImgIcon' src={HMNotificationOffline}  alt="Notification Alert Red" />
                </div>
                : severityType == "unknown"
                ?
                <div className='AlertImgBg' style={{ backgroundColor: "#e3e3e3" }} >
                    <img className='AlertImgIcon' src={HMNotificationUnknown}  alt="Notification Alert Red" />
                </div>
                : 
                null
                // <div className='AlertImgBg' style={{ backgroundColor: "#d9ceeb" }}>
                //     <img className='AlertImgIcon' src={HMNotifOnline} alt="Notification Alert" />
                // </div>
                // <div className='AlertImgBg' style={{ backgroundColor: "#e3e3e3" }} >
                //     <img className='AlertImgIcon' src={HMNotificationUnknown}  alt="Notification Alert Red" />
                // </div>
                
              }
                <div className="CameraStatusNotifyDiv">
                    <div className="NotificationTextDiv">
                        <p className="CameraStatusNameText">{JSON.parse(item?.NotificationData.replaceAll('\n',' ')).Title}</p>
                        <button onClick={() => NotificationRead(item.NotificationId)} className={"MoreBtn" + (isVisible ? 'style="display:block"' : ' style="display:none"')}>
                            <div className={(isVisible ? 'MarkStatusDiv' : '')}></div>
                        </button>
                    </div>
                    <div>
                        <p className="CameraStatusDetailsP">{JSON.parse(item?.NotificationData.replaceAll('\n',' ')).data }
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NotificationItem;